import type { ExtractAtomValue } from 'jotai';
import { atom } from 'jotai';
import type { StudioStore } from '../studio-store';
import type { StudioConfigT } from '../studio-store/types';
export const studioStoreAtom = atom<StudioStore | null>(null);

// storeVersionAtom is read to subscribe to write operations: any mutation to StudioStore's
// frame cache increments the version, causing this atom to re-evaluate and serve fresh data.
export const storeVersionAtom = atom<number>(0);
export const incrementStudioStoreVersionAtom = atom(null, (_get, set) => {
  set(storeVersionAtom, v => v + 1);
});
export const studioConfigAtom = atom<StudioConfigT | null>(null);
export type StudioStoreAtomHydrationList = readonly [typeof storeVersionAtom, ExtractAtomValue<typeof storeVersionAtom>] | readonly [typeof studioConfigAtom, StudioConfigT | null];